import { createRoutine } from 'redux-saga-routines'
import { FETCH_PROMPTS, FETCH_PROMPTS_POST_ORDER } from './types'

export const fetchPrompts = createRoutine(FETCH_PROMPTS)
export const fetchPromptsPostOrder = createRoutine(FETCH_PROMPTS_POST_ORDER)
